import { PrimaryButton } from "components/Button/style";
import { CustomInput } from "components/CustomInput";
import { CustomInputModal } from "components/CustomInputModal";
import { CustomDatePicker } from "components/DatePicker";
import { DropdownSelect } from "components/DropdownSelect";
import { TooltipBootstrap } from "components/TooltipBootstrap";
import { useEmpresas } from "hooks/useEmpresas";
import { useCallback } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm, useWatch } from "react-hook-form";
import {
  BotoesContainer,
  Container,
  IconeInfo,
  Title,
} from "../../../SolicitacaoPlaca/containers/Filtros/style";
import { FILTROS_SOLICITACAO_TERCEIROS_VAZIOS } from "../../constants/filtrosSolicitacaoTerceiros";
import { IFiltrosSolicitacaoTerceiros } from "../../interfaces/IFiltrosSolicitacaoTerceiros";

interface IProps {
  onBuscar: (filtros: IFiltrosSolicitacaoTerceiros) => void;
}

export function Filtros({ onBuscar }: IProps) {
  const { control, handleSubmit, reset, setValue } =
    useForm<IFiltrosSolicitacaoTerceiros>({
      defaultValues: FILTROS_SOLICITACAO_TERCEIROS_VAZIOS,
    });
  const idEmpresa = useWatch({ control, name: "idEmpresa" });
  const periodo = useWatch({ control, name: "periodoSolicitacao" });
  const [dataInicio, dataFim] = periodo ?? [];
  const { empresasOptions } = useEmpresas();

  // DropdownSelect chama onSelect(null) num efeito que depende dele: onSelect precisa ser estável.
  const selecionarEmpresa = useCallback(
    (valor: string | number | null) => {
      setValue("idEmpresa", valor ? Number(valor) : null);
    },
    [setValue]
  );

  function handleLimpar() {
    reset(FILTROS_SOLICITACAO_TERCEIROS_VAZIOS);
    onBuscar(FILTROS_SOLICITACAO_TERCEIROS_VAZIOS);
  }

  return (
    <Container>
      <Title>Filtros</Title>
      <hr />
      <Form noValidate onSubmit={handleSubmit((filtros) => onBuscar(filtros))}>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label>
                PDI{" "}
                <TooltipBootstrap
                  childrenToolTip={
                    <span>
                      Serão considerados todos os PDIs que contenham a palavra
                      informada
                    </span>
                  }
                >
                  <span>
                    <IconeInfo />
                  </span>
                </TooltipBootstrap>
              </Form.Label>
              <Controller
                control={control}
                name="pdi"
                render={({ field }) => (
                  <CustomInput
                    type="text"
                    placeholder="Busque pelo nome"
                    style={{ height: "2.2rem" }}
                    {...field}
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Empresa</Form.Label>
              <DropdownSelect
                options={empresasOptions}
                selectedValue={idEmpresa}
                onSelect={selecionarEmpresa}
                searchable
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>ID Processo</Form.Label>
              <Controller
                control={control}
                name="idProcesso"
                render={({ field: { value, onChange } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value}
                    placeholder="Busque por ID"
                    onConfirm={onChange}
                    validar={false}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou cole os IDs dos processos e tecle ENTER"
                    labelItem="ID Processo"
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Veículo</Form.Label>
              <Controller
                control={control}
                name="veiculo"
                render={({ field: { value, onChange } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value}
                    placeholder="Placa, chassi ou renavam"
                    onConfirm={onChange}
                    validar={false}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou cole as placas, chassis ou renavams e tecle ENTER"
                    labelItem="Veículo"
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Período de solicitação</Form.Label>
              <Controller
                control={control}
                name="periodoSolicitacao"
                render={({ field: { onChange } }) => (
                  <CustomDatePicker
                    placeholder="Selecione o período"
                    rangeSelect
                    startDate={dataInicio ?? undefined}
                    endDate={dataFim ?? undefined}
                    onChange={(datas) => onChange(datas)}
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <BotoesContainer>
              <PrimaryButton
                type="button"
                outline
                variante="primary"
                onClick={handleLimpar}
              >
                Limpar
              </PrimaryButton>
              <PrimaryButton type="submit">Buscar</PrimaryButton>
            </BotoesContainer>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
